export enum PhoneNumberClassification {
    Standard = "Standard",
    Bronze = "Bronze",
    Silver = "Silver",
    Gold = "Gold",
    Platinum = "Platinum"
}
